import { get } from "./api.js";

export interface TutorPresentation {
  tutorProfileId: string;
  providerId: number;
  displayName: string;
  pictureUrl: string | null;
  biography: string | null;
  instruments: string[];
  services: string[];
}

export function getMyTutorPresentation(): Promise<{ profile: TutorPresentation | null }> {
  return get("/me/tutor-profile");
}

export function getStudentTutorPresentations(
  studentId: string,
): Promise<{ tutors: TutorPresentation[] }> {
  return get(`/me/students/${encodeURIComponent(studentId)}/tutors`);
}
